import React, { Fragment } from "react";
import { UniProfileWrapper } from "@modules/study/university";
import API from "@unisearch/helpers/api";
import { LayoutMain } from "@unisearch/theme/layout";
import { UniRanking } from "@modules/study/university/uni_ranking";
import { excerpt } from "@unisearch/helpers";

const Ranking = ({
  universityProfileData,
  universityRankings,
  rankingOverviewText,
  country_name,
  university_name,
}) => {
  return (
    <LayoutMain
      footer_with_evaluation
      title={
        universityProfileData
          ? `${universityProfileData?.universityName} - Ranking`
          : ""
      }
      metaDescription={
        rankingOverviewText
          ? excerpt(rankingOverviewText, 300)
          : "In the process of researching universities you want to apply to, you’ve likely run into university rankings. But what do these numbers mean? A lot goes into informing the position a university or college holds in some of the most popular ranking lists. QS Top Universities, Times Higher Education, US News, Shanghai Rankings, etc. all collect and analyse a lot of data to determine what makes a university a great destination for students. Understanding this data also helps you figure out how to choose the right university for yourself!"
      }
      metaImage={
        universityProfileData?.featureSrc ||
        universityProfileData?.coverphotoLogoSrc
      }
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/study/${country_name}/university/${university_name}/ranking`}
    >
      <Fragment>
        <UniProfileWrapper uniProfileData={universityProfileData || {}}>
          <UniRanking
            rankingInfo={universityRankings}
            rankingOverviewText={rankingOverviewText}
          />
        </UniProfileWrapper>
      </Fragment>
    </LayoutMain>
  );
};

export default Ranking;

export async function getServerSideProps({ params }) {
  const { country_name, university_name } = params;

  let props = {
    universityProfileData: "",
    universityRankings: "",
    rankingComapnies: "",
    rankingOverviewText: "",
    country_name,
    university_name,
  };

  try {
    await API.get(`/public/university/${university_name}`).then((resp) => {
      if (!resp.error && resp.data) {
        props.universityProfileData = resp.data;
      } else {
        props.universityProfileData = "";
      }
    });

    await API.get(`/public/university-ranking/${university_name}`).then(
      (resp) => {
        if (!resp.error && resp.data) {
          props.universityRankings = resp.data;
        }
      }
    );
    await API.get(`/public/university/get-overview/${university_name}`).then(
      (resp) => {
        if (!resp.error && resp.data) {
          props.rankingOverviewText = resp.data.rankingOverview;
        }
      }
    );

    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
